const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "USERS_RETRIEVED":
            return action.users;

        default:
            return state;
    }
}

